const addZeroAtFirst = (value: string) => `0${value}`;
export default addZeroAtFirst;
